import { render, staticRenderFns } from "./UserGroupIndex.vue?vue&type=template&id=58845439&scoped=true"
import script from "./UserGroupIndex.vue?vue&type=script&lang=js"
export * from "./UserGroupIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58845439",
  null
  
)

export default component.exports